import { z } from 'zod';

const CustomerSchema = z.strictObject({
  isCompany: z.boolean(),
  customerName: z.string().optional(),
  titlePrefix: z.string().optional(),
  firstName: z.string().nonempty({ message: 'Validation.FirstName.NotEmpty' }),
  lastName: z.string().nonempty({ message: 'Validation.LastName.NotEmpty' }),
  titleSuffix: z.string().optional(),
  registrationNumber: z.string().optional(),
  vatNumber: z.string().optional(),
  taxNumber: z.string().optional(),
  phoneNumber: z.string().nonempty({ message: 'Validation.PhoneNumber.NotEmpty' }),
  emailAddress: z
    .string()
    .nonempty({ message: 'Validation.EmailAddress.NotEmpty' })
    .email({ message: 'Validation.EmailAddress.InvalidFormat' }),
  billingStreet: z.string().nonempty({ message: 'Validation.Street.NotEmpty' }),
  billingTown: z.string().nonempty({ message: 'Validation.Town.NotEmpty' }),
  billingPostCode: z.string().nonempty({ message: 'Validation.PostCode.NotEmpty' }),
  billingCountryCode: z.string().nonempty({ message: 'Validation.CountryCode.NotEmpty' }),
  differentShipping: z.boolean(),
  shippingAddress: z.strictObject({
    addressId: z.string().optional(),
    street: z.string().optional(),
    town: z.string().optional(),
    postCode: z.string().optional(),
    countryCode: z.string().optional(),
  }).optional(),
}).superRefine((data, ctx) => {

  // firemne udaje
  if (data.isCompany) {
    if (!data.customerName) {
      ctx.addIssue({
        code: 'custom',
        path: ['customerName'],
        message: 'Validation.CustomerName.NotEmpty',
      });
    }

    if (!data.registrationNumber) {
      ctx.addIssue({
        code: 'custom',
        path: ['registrationNumber'],
        message: 'Validation.RegistrationNumber.NotEmpty',
      });
    }
  }

  // dodacia adresa
  if (data.differentShipping) {
    if (!data.shippingAddress?.street) {
      ctx.addIssue({
        code: 'custom',
        message: 'Validation.Street.NotEmpty',
        path: ['shippingAddress.street'],
      });
    }

    if (!data.shippingAddress?.town) {
      ctx.addIssue({
        code: 'custom',
        message: 'Validation.Town.NotEmpty',
        path: ['shippingAddress.town'],
      });
    }

    if (!data.shippingAddress?.postCode) {
      ctx.addIssue({
        code: 'custom',
        message: 'Validation.PostCode.NotEmpty',
        path: ['shippingAddress.postCode'],
      });
    }

    if (!data.shippingAddress?.countryCode) {
      ctx.addIssue({
        code: 'custom',
        message: 'Validation.CountryCode.NotEmpty',
        path: ['shippingAddress.countryCode'],
      });
    }
  }
});

export const CheckoutFormSchema = z.object({
  // Basket
  note: z.string().optional(),
  // Methods
  shippingMethodId: z.string(),
  paymentMethodId: z.string(),
  // Customer
  customer: CustomerSchema,
});

export type CheckoutFormModel = z.infer<typeof CheckoutFormSchema>;
